<template>
  <component
    :is="as"
    :class="textVariants(props)"
  >
    <slot />
  </component>
</template>

<script lang="ts" setup>
/* eslint vue/require-default-prop: off */
import { type TextVariants,textVariants } from './variants';

interface Props {
  align?: TextVariants['align']
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'strong'
  break?: TextVariants['break']
  numeric?: TextVariants['numeric']
  truncate?: TextVariants['truncate']
  weight?: TextVariants['weight']
}

const props = withDefaults(defineProps<Props>(), {
  as: 'span',
});
</script>
